<template>
  <div>
    <CCard class="bg-style2">
      <CCardHeader class="bg-gradient-danger text-white" style="border-top-left-radius: 1rem; border-top-right-radius: 1rem ">
        <span class="font-weight-bold h6"> <CIcon v-if="icon" :name="icon"/> {{ caption }} </span>

        <div class="card-header-actions">
          Total : {{item.length}}
        </div>

      </CCardHeader>
      <CCardBody>
        <CRow>
          <CCol>
            <CDataTable
                :table-filter="{label:''}"
                :hover="hover"
                :striped="striped"
                :bordered="bordered"
                :small="small"
                :fixed="fixed"
                :items="item"
                :fields="fields"
                :items-per-page="small ? 5 : 50"
                :dark="dark"
                pagination
            >
              <template #index="{item,index}">
                <td class="text-center"  @click="toggleDetails(item, index)"> {{ index + 1 }}</td>
              </template>


              <template #members="{item,index}"  >
                <td >
                  <p class="mb-0"> {{ item.authen.filter(obj => { return (obj.type == "66a06852660ccb1debade7c5")})[0].username }}</p>
                  <p class="mb-0" style="white-space: nowrap;">{{ item.userinfo.prefix.filter(item => { return (item.key == lang ) })[0].value }} {{ item.userinfo.firstName.filter(item => { return (item.key == lang ) })[0].value }} {{ item.userinfo.lastName.filter(item => { return (item.key == lang ) })[0].value }}</p>
                </td>
              </template>


              <template #action="{item}">
                <td style="width: 140px">
                  <CRow>
                    <CCol class="text-center">
                      <CButton class="mr-1" v-c-tooltip.hover.click="'Add'" size="sm" color="info" shape="pill" variant="outline" @click="onClick(item)"  >
                        <CIcon name="cil-plus"/>
                      </CButton>


                    </CCol>
                  </CRow>
                </td>
              </template>
              <template #details="{item}">
                <CCollapse :show="Boolean(item._toggled)" :duration="collapseDuration">

                  <CTabs add-tab-classes="mt-1">
                    <CTab>
                      <template slot="title">
                        <CIcon name="cil-briefcase"/> ตำแหน่งงาน
                      </template>
                      <CCardBody>
                        <CDataTable
                            table-filter
                            :fields="field.position"
                            :items="item.value.positions"
                            items-per-page-select
                            :items-per-page="20"
                            hover
                            sorter
                            pagination
                        >
                          <template #index="{item,index}">
                            <td class="text-center"  @click="toggleDetails(item, index)"> {{ index + 1 }}</td>
                          </template>

                          <template #info="{item,index}">
                            <td @click="toggleDetails(item, index)">
                              <span>{{ item.agencies.title.filter(title => { if (title.key == lang) { return title } })[0].value}}</span> <br>
                              <span>{{ item.agency.title.filter(title => { if (title.key == lang) { return title } })[0].value}}</span>
                            </td>
                          </template>

                          <template #position="{item,index}">
                            <td @click="toggleDetails(item, index)">
                              <span>{{ item.type.title.filter(title => { if (title.key == lang) { return title } })[0].value}}</span> <br>
                              <span>{{ item.name.title.filter(title => { if (title.key == lang) { return title } })[0].value}}</span>
                              <!--                              <p>{{ item.work.title.filter(title => { if (title.key == lang) { return title } })[0].value}}</p>-->
                              <p></p>
                            </td>
                          </template>

                          <template #code="{item,index}">
                            <td @click="toggleDetails(item, index)">
                              <span> Code : {{ item.code }} </span> <br>
                              <span> Status : {{ item.status.title.filter(title => { if (title.key == lang) { return title } })[0].value}} </span>
                            </td>
                          </template>


                          <template #dateTime="{item,index}">
                            <td class="text-right"  @click="toggleDetails(item, index)">
                              <span> StartDate : {{ new moment(item.startDate).format("YYYY-MM-DD") }} </span> <br>
                              <span> EndDate : {{ new moment(item.endDate).format("YYYY-MM-DD") }} </span>
                            </td>
                          </template>



                        </CDataTable>
                      </CCardBody>
                    </CTab>




                  </CTabs>


                </CCollapse>
              </template>
            </CDataTable>
          </CCol>
        </CRow>
      </CCardBody>
    </CCard>

  </div>
</template>

<script>

import {mapGetters} from 'vuex'
import Vue from 'vue'

export default {
  name: 'ManagementAccountHistory',
  props: {
    icon: {
      type: String,
      default: 'cil-user'
    },
    caption: {
      type: String,
      default: 'Banks'
    },
    fields: {
      type: Array,
      default() {
        return [
          {key: "index", label: "ลำดับ",  _style: 'width:50px; text-align: center'},
          {key:"code", label:"รหัสบุคลากร", _style: 'width:100px; text-align: center'},
          // {key:"avata", label:"", _style: 'width:50px; text-align: center'},
          // {key:"members", label:"Member",  _style: 'width:200px;'},
          // {key:"agencies", label:"agencies",  _style: 'width:150px; text-align: center'},
          {key:"agency", label:"agency"},

          {key:"info", label:"ชื่อ-สกุล", _style: 'width:300px;'},
          {key:"action", label: "#", _style: 'width:100px; text-align: center'}
          // {key:"attend", label:"Attend Class",  _style: 'width:200px; text-align: center'}
        ]
      }
    },
    type: {
      type: String,
      default: 'cil-user'
    },
    hover: Boolean,
    striped: Boolean,
    bordered: Boolean,
    small: Boolean,
    fixed: Boolean,
    dark: Boolean,


    item: {
      type: Array,
      default() {
        return []
      }
    },

    option: {
      type: Object,
      default: {}
    }
  },

  data: function () {
    return {

      collapseDuration: 0,
      isDialog: false,
      method: [],


      field: {
        position:[
          // {key: "index", label: "#",  _style: 'width:50px; text-align: center'},
          {key: "code", label: "Code", _style: 'width:200px; text-align: center'},
          {key: "info", label: "Info"},
          {key: "position", label: "Position"},
          {key: "dateTime", label:"DateTime",  _style: 'width:190px; text-align: center'},
        ]
      },



      max : 10,
      tabOption: [{
        title:"ตำแหน่งงาน",
        icon:"cil-briefcase",
        type:0,

      },{
        title:"อบรม",
        icon:"cil-school",
        type:1,

      }],


    }
  },

  mounted() {
  },

  created() {
    this.onInit()

  },
  beforeDestroy() {

  },

  methods: {
    onInit() {
      this.onLoad();
    },

    onLoad() {

    },

    errorImage(e) {
      e.target.src = "https://cdn-icons-png.flaticon.com/512/3135/3135715.png"
    },

    toggleDetails (item) {
      item._toggled = !item._toggled
      this.collapseDuration = 300
      this.$nextTick(() => { this.collapseDuration = 0})
    },

    onClick(item){
      this.$emit("select",item)
    }

  },

  computed: {
    ...mapGetters({
      lang: "setting/lang",
    })
  },

  watch: {
  }
}
</script>
<style>

.w50 {
  min-width: 50%;
}

.input-group-append .form-group {
  margin-bottom: 0px;
}

.text-right {
  text-align: end;
}

.bg-login1 {
  border-radius: 1.5rem;
  background: linear-gradient(180deg, #a54af0 0%, #539cf8 60%, #C8CED3 80%);
}
</style>
